<style lang="scss" scoped>
  @import './scss/Public.scss';
</style>

<template>
  <div class="profit-box">
    <div class="title-box">
        <h3>{{version.title}}</h3>
    </div>
    <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
      <profit-table 
      :thData="thData"
      :trData="trData"
      :page="page"
      :selPage="selPage"
      :curArea="curArea"
      :operate="operate"
      :multiLanguage="version"
      @tableChange="requestHandle"
      >
        <div slot="handle" class="conditions">
          <div class="condition change-el-input-group-style">
            <el-input v-model="searchVal">
              <el-select v-model="searchKey" slot="prepend" style="width: 105px;">
                <el-option v-for="(item, index) in version.selectArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-button slot="append" @click="requestHandle">{{version.search}}</el-button>
            </el-input>
          </div>
        </div>
      </profit-table>
    </div>
  </div>
</template>

<script>
import ProfitTable from "./ProfitTable";
import { URL_SHARE_VERSION, URL_VERSION_BACK } from 'api/commissionApi';
let data = () => {
  return {
    loading: false,
    trData: [],
    searchKey: 'LOGIN',
    searchVal: '',
    report_id: '',
    report_id_list: {},
    page: {
      active: 1,
      pageLeng: 0
    },
    selPage: {
      list: [5, 10, 25, 50],
      active: localStorage.pageMaxIndex,
      limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
    },
    operate:{
      btn: true,
      showKey: [{key: 'IS_DELETED',value: 0}],
      url: URL_VERSION_BACK,
    }
  }
}

const mounted = function() { this.requestHandle() }

const methods = {
    requestHandle() {
        this.loading = true;
        let obj = {
          params: {
            area: this.curArea,
            searchKey: this.searchKey,
            searchVal: this.searchVal,
            pageNum: this.page.active - 1,
            pageSize: this.selPage.limit
          }
        }
        this.$http.get(URL_SHARE_VERSION, obj).then(res => {
            this.trData = res.data.data.rows;
            this.page.pageLeng = res.data.data.count;
            this.loading = false;
            this.trData.forEach(t => {
              t.is_deleted = this.version.status_mapper[t.IS_DELETED];
            });
        });
    }
}

const props = {
  curArea: {
    type: String,
    required: true
  }
}

const mixins = [
  require("common/mixin/base.js").base({ version: "versionReport"}),
]

const computed = {
  thData() {
    return this.version.first_row
  }
}

const watch = {
  curArea() {
    this.page.active = 1;
    this.ib_id = '';
    this.requestHandle();
  },
  version(newVal, oldVal) {
    this.trData.forEach(t => {
        t.is_negative_before = newVal.result_mapper[t.IS_NEGATIVE_BEFORE];
        t.is_deleted = newVal.status_mapper[t.IS_DELETED];
    });
  } 
}

const components = { ProfitTable,}

export default {
  data,
  mounted,
  methods,
  props,
  mixins,
  computed,
  watch,
  components,
}
</script>



// WEBPACK FOOTER //
// VersionReport.vue?2ab20bf8